import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=4846839b&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=4846839b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846839b",
  null
  
)

export default component.exports